export default __webpack_public_path__ + "static/media/profile_male@3x.44b2b0ca.png";